export type ReportTargetType = "message" | "user";
export type ReportCategory = "harassment" | "spam" | "inappropriate" | "other";
export type ReportStatus = "open" | "resolved" | "dismissed";
export type ReportAction = "dismiss" | "resolve" | "remove_message";

export interface UgcReport {
  id: string;
  tenant_id: string;
  reporter_id: string;
  target_type: ReportTargetType;
  target_id: string;
  target_user_id: string | null;
  room_id: string;
  category: ReportCategory;
  details: string | null;
  snapshot: unknown;
  status: ReportStatus;
  created_at: number;
  resolved_at: number | null;
  resolution_note: string | null;
}

export interface ReportListResponse {
  reports: UgcReport[];
}

export interface ReportResponse {
  report: UgcReport;
}

export interface ContentFilterConfig {
  enabled: boolean;
  terms: string[];
}

/** Matches api/src/services/ugc.ts */
export const CONTENT_FILTER_MAX_TERMS = 100;
export const CONTENT_FILTER_TERM_MIN_NORMALIZED = 4;
export const CONTENT_FILTER_TERM_MAX_RAW = 80;
export const CONTENT_FILTER_TOTAL_MAX = 4000;
export const REPORT_NOTE_MAX = 2000;

export const ADMIN_FORBIDDEN_MESSAGE =
  "管理権限がありません。ワークスペースの所有者または管理者のみがこの画面を利用できます。";
